// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/draft_schedule_cycle_summary.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/schedules/v1/resources/draft_schedule_cycle_summary.proto.
 */
export const file_studyo_today_schedules_v1_resources_draft_schedule_cycle_summary = /*@__PURE__*/
  fileDesc("CkZzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9kcmFmdF9zY2hlZHVsZV9jeWNsZV9zdW1tYXJ5LnByb3RvEiNzdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcyKTAQoZRHJhZnRTY2hlZHVsZUN5Y2xlU3VtbWFyeRIYChBkcmFmdF9zZXNzaW9uX2lkGAEgASgJEhkKEXNjaGVkdWxlX2N5Y2xlX2lkGAIgASgJEjAKDGNyZWF0ZWRfdGltZRgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDwoHdXNlcl9pZBgEIAEoCUIrqgIoU3R1ZHlvLlRvZGF5LlNjaGVkdWxlcy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.schedules.v1.resources.DraftScheduleCycleSummary.
 * Use `create(DraftScheduleCycleSummarySchema)` to create a new message.
 */
export const DraftScheduleCycleSummarySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_draft_schedule_cycle_summary, 0);

